// extracted by mini-css-extract-plugin
module.exports = {"renderWrapper":"c_d","renderContainer":"c_f","tabletContainer":"c_g"};